export default function Location() {
  return (
    <section id="localizacao" className="py-8 md:py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-green-800 mb-3">Nossa Localização</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-3 md:mb-6"></div>
          <p className="text-sm md:text-xl text-gray-700 max-w-3xl mx-auto">
            Visite nossa usina de beneficiamento no coração do Cariri paraibano
          </p>
        </div>
        
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-12">
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg shadow-lg p-5 md:p-8">
              <div className="flex items-start mb-4 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-600 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-lg md:text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-green-800 mb-1 md:mb-2">Endereço</h3>
                  <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                    Fazenda Agreste<br />
                    Sumé - PB<br />
                    CEP: 58540-000
                  </p>
                </div>
              </div>
              
              <div className="flex items-start mb-4 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-600 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                  <i className="ri-phone-line text-lg md:text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-green-800 mb-1 md:mb-2">Telefone</h3>
                  <a href="tel:+5583999845954" className="text-xs md:text-base text-gray-700 hover:text-green-600 transition-colors cursor-pointer">
                    (83) 99984-5954
                  </a>
                </div>
              </div>
              
              <div className="flex items-start mb-4 md:mb-6">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-600 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                  <i className="ri-instagram-line text-lg md:text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-green-800 mb-1 md:mb-2">Instagram</h3>
                  <a 
                    href="https://instagram.com/laticinio_agubel" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-xs md:text-base text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
                  >
                    @laticinio_agubel
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-green-600 rounded-full flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                  <i className="ri-facebook-box-line text-lg md:text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-base md:text-xl font-bold text-green-800 mb-1 md:mb-2">Facebook</h3>
                  <a 
                    href="https://facebook.com/laticinoagubel" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-xs md:text-base text-gray-700 hover:text-green-600 transition-colors cursor-pointer"
                  >
                    Laticínio Agubel
                  </a>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-lg overflow-hidden h-64 md:h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3959.123456789!2d-37.0!3d-7.67!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zN8KwNDAnMTIuMCJTIDM3wrAwMCcwMC4wIlc!5e0!3m2!1spt-BR!2sbr!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Agubel"
              ></iframe>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-lg p-5 md:p-8 text-center text-white shadow-xl">
            <h3 className="text-lg md:text-2xl font-bold mb-3 md:mb-4">Horário de Funcionamento</h3>
            <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-2xl mx-auto">
              <div>
                <p className="text-sm md:text-lg font-semibold mb-1 md:mb-2">Segunda a Sexta</p>
                <p className="text-sm md:text-lg">08:00 - 17:00</p>
              </div>
              <div>
                <p className="text-sm md:text-lg font-semibold mb-1 md:mb-2">Sábado</p>
                <p className="text-sm md:text-lg">08:00 - 12:00</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
